export * from "./classes/tab";
export * from "./components/tabset";
export * from "./directives/tab-content";
export * from "./directives/tab-header";
export * from "./tab.module";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/modules/tabs/index.js
// module id = 519
// module chunks = 0